import { render, staticRenderFns } from "./OxygenFocusPointInput.vue?vue&type=template&id=9c117288&"
import script from "./OxygenFocusPointInput.vue?vue&type=script&lang=ts&"
export * from "./OxygenFocusPointInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports